import { EmptyState } from "./EmptyState";

export const Canvas = Object.assign(() => <div />, {
  EmptyState,
});
